// extracted by mini-css-extract-plugin
export default {"noPermission":"index_noPermission__g9LjH","highlight":"index_highlight__ft-pC","qrCode":"index_qrCode__kFstg"};